export enum AttendanceType {
  Attended = 'attended',
  Late = 'late',
  Missed = 'missed',
}
